import React, { useState, useEffect } from 'react';
import Collapsible from 'react-collapsible';
import CheckinStatusGroup from './CheckinStatusGroup';
import _ from 'lodash';

const CHECKIN_STORAGE_KEY = `EHS.PCMH.ALL_CHECKIN_COLLAPSED_STATES`;

const CheckinStatus = props => {
    const checkin = props.checkin; // 1, 2, or 3
    const checkinData = props.data || {}; // stats
    const practiceId = props.practiceId;
    const [isCollapseOpen, setIsCollapseOpen] = useState(false);
    const practiceKey = `practiceId${practiceId}`;
    const checkinKey = `isCheckin${checkin}CollapseOpen`;

    const concatInProgress = [].concat(checkinData['Not Started'] || [], checkinData['Started'] || [], checkinData['Revision Required'] || []);
    const concatInReview = checkinData['Review Ready'] || [];
    const concatReady = [].concat(checkinData['Q-Ready'] || [], checkinData['Q-Submit'] || [], checkinData['Q-Met'] || [], checkinData['Prevalidated'] || []);

    // What to sort the items by.
    const sortByString = props.sortByString || 'code';

    const inProgress = concatInProgress.sort(compareValues(sortByString));
    const inReview = concatInReview.sort(compareValues(sortByString));
    const ready = concatReady.sort(compareValues(sortByString));

    function compareValues(key, sortOrder = 'asc') {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                console.error(`Error: Could not sort items by the key "${key}" because it does not exist on either object being compared.`);
                return 0;
            }

            const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
            const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }

            const result = sortOrder === 'desc' ? comparison * -1 : comparison;

            return result;
        };
    }

    const handleCollapse = () => {
        const state = !isCollapseOpen;
        setIsCollapseOpen(state);

        // Persist to localStorage.
        // Add this practice's checkin status to localStorage.
        const allCollapsedStates = parseLocalStorage();
        allCollapsedStates[practiceKey] = { ...allCollapsedStates[practiceKey], [checkinKey]: state };
        localStorage.setItem(CHECKIN_STORAGE_KEY, JSON.stringify(allCollapsedStates));
    };

    function getCheckinCollapsedStatus() {
        // Check if we have saved this checkin in this practice before.
        const status = _.get(parseLocalStorage(), `${practiceKey}.${checkinKey}`, true);
        return status;
    }

    function parseLocalStorage() {
        return JSON.parse(localStorage.getItem(CHECKIN_STORAGE_KEY)) || {};
    }

    useEffect(() => {
        // Set the collapsed state when the page loads.
        const init = getCheckinCollapsedStatus();
        setIsCollapseOpen(init);
    }, [inProgress, inReview, ready]);

    const checkinName = `Check-in ${checkin}`;
    return (
        <Collapsible
            trigger={
                <div className="CheckinStatus__titlebar">
                    <div className="Collapsible__container">
                        <h2>{checkinName}</h2>
                        <div className="CheckinStatus__stats" />
                        <span className="Select-arrow"></span>
                    </div>
                </div>
            }
            handleTriggerClick={handleCollapse}
            open={isCollapseOpen}>
            <div className="CheckinStatusGroups">
                <CheckinStatusGroup name={'In Progress'} criteria={inProgress} />
                <CheckinStatusGroup name={'Under Review'} criteria={inReview} />
                <CheckinStatusGroup name={'Ready'} criteria={ready} />
            </div>
        </Collapsible>
    );
};

export default CheckinStatus;
